import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const FeedbackIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.246 5.996a3.75 3.75 0 0 1 3.75-3.75h8a.75.75 0 0 1 0 1.5h-8a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h2.007a.75.75 0 0 1 .75.75v2.04l3.282-2.625a.75.75 0 0 1 .468-.164h5.493a2.25 2.25 0 0 0 2.25-2.25v-5a.75.75 0 0 1 1.5 0v5a3.75 3.75 0 0 1-3.75 3.75h-5.23l-3.39 2.713a1.306 1.306 0 0 1-2.123-1.02v-1.693H5.996a3.75 3.75 0 0 1-3.75-3.75v-9ZM6.998 8.25a.75.75 0 1 0 0 1.5h4.001a.75.75 0 0 0 0-1.5H6.998Zm0 4.001a.75.75 0 0 0 0 1.5H16a.75.75 0 0 0 0-1.5H6.998ZM19.074 2.246c-.464 0-.91.185-1.238.513L14.764 5.83a1.75 1.75 0 0 0-.513 1.238V8.5c0 .69.56 1.25 1.25 1.25h1.43c.463 0 .909-.185 1.237-.513l3.073-3.073a1.75 1.75 0 0 0 0-2.475l-.93-.93a1.75 1.75 0 0 0-1.237-.512Zm-.177 1.573a.25.25 0 0 1 .354 0l.93.93a.25.25 0 0 1 0 .354l-3.074 3.072a.25.25 0 0 1-.177.074h-1.179v-1.18a.25.25 0 0 1 .073-.177l3.073-3.073Z"
      fill="currentColor"
    />
  </IconBase>
);

export default FeedbackIcon;
